/** Where the user opened the deposit sheet (UI entry point). */
export type DepositUiSource =
  | "pvp_top_bar"
  | "pvp_betting_panel"
  | "pvp_resolved_winner"
  | "profile"
  | "inventory"
  | "inventory_shortfall"

let activeDepositUiSource: DepositUiSource | null = null

export function setAnalyticsDepositUiSource(source: DepositUiSource): void {
  activeDepositUiSource = source
}

export function getAnalyticsDepositUiSource(): DepositUiSource | "unknown" {
  return activeDepositUiSource ?? "unknown"
}
